import type { ReactNode } from "react";

type Props = {
  icon?: ReactNode;
  title: string;
  desc?: string;
  action?: ReactNode;
};

export function EmptyState({ icon, title, desc, action }: Props) {
  return (
    <div className="rounded-2xl bg-white py-16 px-6 text-center ring-1 ring-navy-100">
      {icon ? (
        <div className="mx-auto mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-navy-50 text-navy-500">
          {icon}
        </div>
      ) : null}
      <h3 className="text-lg font-bold text-navy-800">{title}</h3>
      {desc ? (
        <p className="mt-1 text-sm text-navy-500 max-w-sm mx-auto">{desc}</p>
      ) : null}
      {action ? <div className="mt-6">{action}</div> : null}
    </div>
  );
}
